// removed by extract-text-webpack-plugin
module.exports = {"body":"_2CMK6","grid":"_3mpVe","aside":"_1EByM","plansTable":"aDLWz"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/styles.module.css
// module id = 250
// module chunks = 0